import React, { useEffect, useState } from 'react';

interface GeneratingDotsProps {
  text?: string;
}

function GeneratingDots({ text = "Generating" }: GeneratingDotsProps) {
  const [dots, setDots] = useState('');
  
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => {
        if (prevDots.length >= 3) return '';
        return prevDots + '.';
      });
    }, 400);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="flex items-center">
      <span>{text}{dots}</span>
      <span className="invisible">..</span> {/* This ensures the width stays constant */}
    </div>
  );
}

export default GeneratingDots;